module.exports = __webpack_public_path__ + "static/media/loading.203f7a6d.svg";